'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZyppdComponents = exports.ModalsContext = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themes = require('./themes');

var _popups = require('../components/popups');

var _buttons = require('../components/buttons');

var _reactToastNotifications = require('react-toast-notifications');

var _hooks = require('../hooks');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // export const ModalsContext = React.createContext({ checking: true });


var ModalsContext = exports.ModalsContext = _react2.default.createContext({});

function Check(_ref) {
  var isVisible = _ref.isVisible,
      close = _ref.close,
      message = _ref.message,
      cb = _ref.cb;

  function handleConfirm() {
    cb();
    close();
  } // const doc = document.body || false
  // const el = typeof document !== `undefined` ? document.createElement('div') : null


  return typeof document !== 'undefined' ? _reactDom2.default.createPortal(_react2.default.createElement(_popups.Modal, {
    isVisible: isVisible,
    close: close,
    shade: true,
    style: {
      zIndex: '55'
    },
    title: message
  }, _react2.default.createElement('div', {
    style: {
      display: 'flex',
      gap: '1em' // marginTop: '1em'

    }
  }, _react2.default.createElement(_buttons.PrimaryBtn, {
    type: 'negative',
    fullWidth: true,
    onClick: close,
    style: {
      marginRight: '.25em'
    }
  }, 'Cancel'), _react2.default.createElement(_buttons.PrimaryBtn, {
    type: 'positive',
    fullWidth: true,
    onClick: handleConfirm,
    style: {
      marginLeft: '.25em'
    }
  }, 'Confirm'))), document.body) : '';
}

function ModalsProvider(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      checking = _useState2[0],
      setChecking = _useState2[1];

  return _react2.default.createElement(ModalsContext.Provider, {
    value: {
      checking: checking,
      setChecking: setChecking
    }
  }, props.children, _react2.default.createElement(Check, {
    isVisible: checking.checking,
    cb: checking.cb,
    message: checking.message,
    close: function close() {
      return setChecking(false);
    }
  }));
}

var ZyppdComponents = exports.ZyppdComponents = function ZyppdComponents(_ref2) {
  var _ref2$brandColor = _ref2.brandColor,
      brandColor = _ref2$brandColor === undefined ? '#43E896' : _ref2$brandColor,
      _ref2$range = _ref2.range,
      range = _ref2$range === undefined ? ["#fafafa", "#f7f7f7"] : _ref2$range,
      children = _ref2.children,
      _ref2$toastDuration = _ref2.toastDuration,
      toastDuration = _ref2$toastDuration === undefined ? 2500 : _ref2$toastDuration,
      _ref2$toastPosition = _ref2.toastPosition,
      toastPosition = _ref2$toastPosition === undefined ? "bottom-center" : _ref2$toastPosition;
  if (range[0] === null, range[1] === null) range = ["#fafafa", "#f7f7f7"];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      checking = _useState4[0],
      setChecking = _useState4[1];

  return _react2.default.createElement(_styledComponents.ThemeProvider, {
    theme: (0, _themes.Themes)(brandColor, range)
  }, _react2.default.createElement(_themes.GlobalStyle, null), _react2.default.createElement(_reactToastNotifications.ToastProvider, {
    autoDismiss: true,
    autoDismissTimeout: toastDuration,
    components: {
      Toast: _popups.ToastItem
    },
    placement: toastPosition
  }, _react2.default.createElement(ModalsProvider, {
    test: "test"
  }, children)));
};